import React from 'react';

import FormikFieldBase, { FormikFieldProps } from '@common/react/components/Forms/FormikField/FormikField';
import { FormikPhoneControl, FormikPhoneControlProps } from '@common/react/components/Forms/FormikPhoneControl/FormikPhoneControl';
import PhoneOrEmailInput, { PhoneOrEmailInputProps } from '@common/react/components/Forms/PhoneOrEmailInput/PhoneOrEmailInput';

const FormikField: typeof FormikFieldBase & FormikFieldExtensions = (props: FormikFieldProps) => <FormikFieldBase {...props} />;

const FormikFieldInput = (props: Omit<FormikFieldProps, 'render' | 'children'>) => {
	return <FormikField
		{...props}
	/>;
};

const FormikFieldTextArea = (props: Omit<FormikFieldProps, 'render' | 'inputProps'> & { textareaProps: React.HTMLProps<HTMLTextAreaElement>}) => {
	const {
		textareaProps,
		...rest
	} = props;
	return <FormikField
		{...rest}
	>
		{({ field }) => <textarea
			className="form-control"
			type="text"
			id={field.name}
			{...textareaProps}
			{...field}
		/>}
	</FormikField>;
};

const FormikFieldEmail = (props: Omit<FormikFieldProps, 'render' | 'children' | 'fieldName'> & { fieldName?: string }) => {
	return <FormikField
		title="Email"
		fieldName="email"
		{...props}
	/>;
};

const FormikFieldPhone = (props: Omit<FormikFieldProps, 'render' | 'children' | 'fieldName'>
	& { fieldName?: string } & { phoneControlProps?: Omit<FormikPhoneControlProps, 'fieldProps'> }) => {
	const {
		phoneControlProps,
		...rest
	} = props;
	return <FormikField
		title="Phone"
		fieldName="phone"
		{...rest}
	>
		{(fieldProps) => <FormikPhoneControl fieldProps={fieldProps} {...phoneControlProps} />}
	</FormikField>;
};

const FormikFieldPhoneOrEmail = (props: Omit<FormikFieldProps, 'render' | 'children' | 'fieldName'>
	& { fieldName?: string } & { phoneOrEmailControlProps: Omit<PhoneOrEmailInputProps, 'fieldProps'> }) => {
	const {
		phoneOrEmailControlProps,
		...rest
	} = props;
	return <FormikField
		title="Email or Phone Number"
		fieldName="info"
		{...rest}
	>
		{(fieldProps) => <PhoneOrEmailInput
			fieldProps={fieldProps}
			className="form-control"
			{...phoneOrEmailControlProps}
		/>}
	</FormikField>;
};

FormikField.Input = FormikFieldInput;
FormikField.TextArea = FormikFieldTextArea;
FormikField.Email = FormikFieldEmail;
FormikField.Phone = FormikFieldPhone;
FormikField.PhoneOrEmail = FormikFieldPhoneOrEmail;

export interface FormikFieldExtensions {
	Input: typeof FormikFieldInput;
	TextArea: typeof FormikFieldTextArea;
	Email: typeof FormikFieldEmail;
	Phone: typeof FormikFieldPhone;
	PhoneOrEmail: typeof FormikFieldPhoneOrEmail;
}

export default FormikField;
